// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
export enum SpotlightTypes {
	CREATE_IDEA = 'CREATE_IDEA_CLOSED',
	CREATE_INSIGHT = 'CREATE_INSIGHT_CLOSED',
	CREATE_DELIVERY_TICKET = 'CREATE_DELIVERY_TICKET_CLOSED',
	JOIN_COMMUNITY = 'JOIN_COMMUNITY_CLOSED',
}
